// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_3h3Il9uNLr5fbwO3sY7dE5","Content":"_2ZditHgRFZOC1a2dK983p0","UserContent":"_24Utn3qteGS9vBmDj9SJZk","PublicContent":"_2v5rjHUE8sZf28JRpbjiaZ","Container":"_1xsS7UDm5p6NfPXyPFifEr","Column":"_2qs3oPPV8cb1v7cTe8QAKQ"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/styles.module.css
// module id = 113
// module chunks = 0